FrameModules.add('WikiRelatedFrameModule', function() {
   WikiRelatedFrameModule.initialize();
});

export var WikiRelatedFrameModule = (window.WikiRelatedFrameModule = {
   initialize: function() {
      when($('wikiRelatedInput'), function(el) {
         DeviceFinder.initialize(el);
      });
   },
});
